var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.84375,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#00CE8D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10534_15359)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37565 7.75C8.58462 7.75 7.94336 8.39126 7.94336 9.18229V17.5156C7.94336 18.3067 8.58462 18.9479 9.37565 18.9479H15.6257C16.4167 18.9479 17.0579 18.3067 17.0579 17.5156V11.7447C17.0579 11.3266 16.8752 10.9294 16.5578 10.6572L13.5683 8.09481C13.3087 7.87231 12.9781 7.75 12.6361 7.75H9.37565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0552 11.6562C17.0314 11.271 16.8528 10.9101 16.5578 10.6572L13.5683 8.09481C13.3087 7.87231 12.9781 7.75 12.6361 7.75H12.6309V8.40104V10.224C12.6309 11.015 13.2721 11.6562 14.0632 11.6562H16.4069H17.0552Z",
    fill: "#1313C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10534_15359"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 7.09375,
    width: 12.5,
    height: 12.5,
    rx: 6.25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/Contract.501a0eed9ab0164135dfedd24ea53de6.svg";
export { ForwardRef as ReactComponent };